module.exports = __webpack_public_path__ + "static/media/snow.88213098.svg";